import creditCardType from 'credit-card-type';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const email = (value) => (value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? <FormattedMessage id="error-invalid-email" defaultMessage="Invalid email" /> : undefined);

const passwordConfirmation = (value, allValues) => (value !== allValues.user.password
    ? <FormattedMessage id="error-password-not-match" defaultMessage="Password doesn't match" /> : undefined);

const required = (value) => ((value) ? undefined : <FormattedMessage id="required-message" defaultMessage="Required" />);

const minLength = (min) => (value) => (value && value.length < min ? <FormattedMessage id="error-min-length" defaultMessage={`Must be ${min} or more characters`} values={{ min }} /> : undefined);

/**
 * Phone number must have only numbers, white spaces, (, ), + or -
 * @param {string} value
 * @returns
 */
const phone = (value) => (value && !/^[0-9 ()+-]*$/.test(value)
    ? <FormattedMessage id="invalid-phone-number" defaultMessage="Invalid phone number" /> : undefined);

/**
 * According to https://en.wikipedia.org/wiki/Postal_code, zip code (or postal code)
 * only allows numbers, basic latin letters, empty spaces and hyphens.
 * @param {string} value
 * @returns
 */
const zipCode = (value) => (value && !/^[0-9a-zA-Z -]*$/.test(value)
    ? <FormattedMessage id="invalid-zip-code" defaultMessage="Invalid zip code" /> : undefined);

const cardNumberLength = (cardNum) => {
    let result = <FormattedMessage id="add-funds-k-wallet-invalid-card-number-error" defaultMessage="Invalid card number" />;
    if (!cardNum || cardNum === '') return result;

    const noSpaceNumber = cardNum.trim().replaceAll(' ', '');
    const possibleCards = creditCardType(noSpaceNumber);
    possibleCards.forEach((card) => {
        if (card.type && card.lengths && card.lengths.indexOf(noSpaceNumber.length) > -1) {
            result = undefined;
        }
    });
    return result;
};

const validators = {
    required,
    email,
    passwordConfirmation,
    minLength,
    phone,
    zipCode,
    cardNumberLength,
};

export default validators;



/** WEBPACK FOOTER **
 ** ./src/components/shared/validators.js
 **/